import React, { forwardRef } from 'react';

import CommonNotification from './CommonNotification';
import { ICONS } from '../icons';

const ErrorNotification = forwardRef(
  ({ id, message, subMessage, messageParams, subMessageParams, showMarkerText }, ref) => {
    return (
      <CommonNotification
        id={id}
        ref={ref}
        message={message}
        messageParams={messageParams}
        subMessage={subMessage}
        subMessageParams={subMessageParams}
        showMarkerText={showMarkerText}
        MarkerIcon={ICONS.Cross}
        markerText='error'
        markerStyle='error'
      />
    );
  },
);
ErrorNotification.displayName = 'ErrorNotification';

export default ErrorNotification;
